/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { accessUpdateRole } from "../funcs/accessUpdateRole.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { Role } from "../models/components/role.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  UpdateRoleRequest,
  UpdateRoleSecurity,
} from "../models/operations/updaterole.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type UpdateRoleMutationVariables = {
  request: UpdateRoleRequest;
  security?: UpdateRoleSecurity | undefined;
  options?: RequestOptions;
};

export type UpdateRoleMutationData = Role;

export type UpdateRoleMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * updateRole access
 *
 * @remarks
 * Update an existing custom role.
 */
export function useUpdateRoleMutation(
  options?: MutationHookOptions<
    UpdateRoleMutationData,
    UpdateRoleMutationError,
    UpdateRoleMutationVariables
  >,
): UseMutationResult<
  UpdateRoleMutationData,
  UpdateRoleMutationError,
  UpdateRoleMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildUpdateRoleMutation(client, options),
    ...options,
  });
}

export function mutationKeyUpdateRole(): MutationKey {
  return ["@gram/client", "access", "updateRole"];
}

export function buildUpdateRoleMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: UpdateRoleMutationVariables,
  ) => Promise<UpdateRoleMutationData>;
} {
  return {
    mutationKey: mutationKeyUpdateRole(),
    mutationFn: function updateRoleMutationFn({
      request,
      security,
      options,
    }): Promise<UpdateRoleMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(accessUpdateRole(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
